import React from 'react';

import {observer} from 'mobx-react';
import {Link} from "../../../../core/components/link/link";

import {EntityLogo, EntityLogoProps} from "../../../../core/components/logos/entity-logo";
import {TOOLTIP_PLACEMENT} from "../../../../core/components/tooltip/tooltip-consts";
import {ACTION_TYPES} from "../../../../core/consts";
import {ScoresListWidgetProps} from "../../models/scores-list-widget.props";
import {CompetitionGamesViewModel} from "../../models/competition-games-view-model";
import {Tooltip} from "../../../../core/components/tooltip/tooltip";
import {APP, ENTITY_TYPES, STANDINGS_TABS} from "../../../../core/app/consts";
import {Text} from "../../../../core/components/misc/text/text";
import {Image} from "../../../../core/components/image/image";
import {StarSelection} from "../../../../core/components/entity-selection/star-selection";

export class ScoresListWidgetCompetitionTitleComponentProps extends ScoresListWidgetProps {
  onLoad: Function;
  competition: CompetitionGamesViewModel;
  onSelection: Function;
}


export const ScoresListWidgetCompetitionTitle = observer((props: ScoresListWidgetCompetitionTitleComponentProps) => {
  const onCompetitionClick = () => {
    props.controller.action(ACTION_TYPES.entityClick, {
      entityId: props.competition.id,
      entityType: APP.ANALYTICS.ENTITY_DISPLAY_TYPES[props.competition.objectType],
      source: APP.ANALYTICS.SOURCES[props.controller.state.currentLinkModel.name],
      currentLinkModel: props.controller.state.currentLinkModel.name,
      sportTypeId: props.competition.sport.id
    });

    return true;
  }

  const competitionLinkProps = {
    className: 'scores-list-widget-competition-title-competition-name',
    model: props.competition.linkModel,
    routeProps: {
      dataSource: {
        entity: props.competition.domainModel
      }
    },
    onClick: () => onCompetitionClick()
  }

  const starIconProps = {
    className: 'scores-list-widget-competition-title-star',
    id: props.competition.id,
    type: props.competition.objectType,
    height: 36,
    buttonStyle: {
      margin: -8,
      [props.controller.device.isRtl ? 'marginLeft' : 'marginRight']: 0
    },
    onClick: (e, isSelected) => props.onSelection && props.onSelection(props.competition.id, isSelected),
    sportTypeId: props.competition.sport.id,
    source: props.isLive ? APP.ANALYTICS.SOURCES.liveScores : APP.ANALYTICS.SOURCES.scores
  }

  const tooltipProps = {
    title: props.controller.state.terms.SEE_COMPETITION_TABLE.format({'LEAGUE_NAME': props.competition.name}),
    placement: props.controller.device.isRtl ? TOOLTIP_PLACEMENT.right : TOOLTIP_PLACEMENT.left,
    style: {
      marginBottom: -2
    }
  }

  const onStandingsClick = () => {
    props.controller.action(ACTION_TYPES.standingsClick, {
      entityType: ENTITY_TYPES.competition,
      entityId: props.competition.id,
      source: APP.ANALYTICS.SOURCES[props.controller.state.currentLinkModel.name],
      standingsTab: STANDINGS_TABS.all,
      sportTypeId: props.competition.sport.id
    });

    return true;
  }

  const linkProps = {
    model: props.competition.standingsLinkModel,
    onClick: () => onStandingsClick()
  }

  const entityLogoProps: EntityLogoProps = {
    entity: props.competition,
    width: 24,
    height: 24,
  }

  const imageProps = {
    src: props.competition.standingsIcon,
    className: 'scores-list-widget-competition-title-standings-icon',
    style: {
      width: 16,
      height: 16,
    }
  }
  const countGames = props.controller.state.isLiveFilter ? props.competition.liveGames : props.competition.games.length;

  return (
    <div className={'scores-list-widget-competition-title-container'}>
      <div className={'scores-list-widget-competition-title-logo-and-star'}>
        {
          !props.controller.state.appSettings.isWidget && <StarSelection {...starIconProps}/>
        }
        <div className={'scores-list-widget-competition-title-logo'}>
          <EntityLogo {...entityLogoProps}/>
        </div>
      </div>
      <div className={'scores-list-widget-competition-title-competition-and-country'}>
        <Link {...competitionLinkProps}>
          {
            `${props.competition.name} (${countGames})`
          }
        </Link>
        <Text text={props.competition.country.name} className={'scores-list-widget-competition-title-country-name'}/>
      </div>
      {
        !props.controller.state.appSettings.isWidget && props.competition.hasStandings && <Tooltip {...tooltipProps}>
          <Link {...linkProps}>
            <Image {...imageProps}/>
          </Link>
        </Tooltip>
      }
    </div>
  );
});
